<div class="p-1 text-center ml-2 mr-2">
    <img src={{item.img}} class="img-cover" />
    <p class="name mt-1">{{item.name}}</p>
    <div class="description ellipsis">
        {{item.description}}
    </div>
    <button type="button" class="btn btn-primary pl-5 pr-5" (click)="goToItem()">Thử</button>
</div>